const BASE_URL = process.env.REACT_APP_API_KEY;

export const IMAGE_ADMIN_PROFILE = BASE_URL + '/profile/api/'
export const IMAGE_RIDER_PROFILE = BASE_URL + '/profile/api/'